/** How a header pill reports its count. On screen the badge is only a dot, as ChatGPT's top bar
 *  marks something new; the number lives in the button's accessible name instead. */

/** The text a count badge shows: anything past 99 reads "99+". */
export function formatHeaderBadge(count: number): string {
  return count > 99 ? '99+' : String(count);
}

/** The button's accessible name with its count, unless the builder already wrote the count in. */
export function headerActionName(label: string, badge: number | undefined): string {
  if (typeof badge !== 'number' || badge <= 0) return label;
  const count = formatHeaderBadge(badge);
  return label.includes(count) ? label : `${label}, ${count} unread`;
}
